
const ServiceOrderModel = function (){
    const name = 'service_order';
    return {
        name,
        state:{
            condition:{
                reservationCode:'',
                status:'',
            },
            newModal:{
                id:'',
                name:'',
                mobile:'',
                email:'',
                password:'',
                con_password:'',
                permission:'',
                roleId:'',
                sex:'',
                qq:'',
                weibo:'',
                wechat:'',
                idCode:'',
                idType:'',
            },
            list:[],
            page:{
                pageSize:30,
                current:1,
                total:0,
            }
        },
        selectors:(state, props) => {
            const currentState = state[name];
            const selectors = {
                getCondition:()=>currentState.condition,
                getNewModalData:()=>currentState.newModal,
                getList:()=>currentState.list,
                getPage:()=>currentState.page,
            };
            return selectors;
        },
        api:{},
        actions:{
            changeCondition:(key,value) => (dispatch,getState) => {
                dispatch({
                    type:'CHANGE_SERVICE_ORDER_CONDITION',
                    key,
                    value
                })
            },
            changeNewModalData:(key,value) => (dispatch,getState) => {
                dispatch({
                    type:'CHANGE_SERVICE_ORDER_MODAL',
                    key,
                    value
                })
            },
            changeList:(list) => (dispatch,getState) => {
                dispatch({
                    type:'CHANGE_SERVICE_ORDER_LIST',
                    list
                })
            },
            changePage:(page) => (dispatch,getState) => {
                dispatch({
                    type:'CHANGE_SERVICE_ORDER_PAGE',
                    page
                })
            }
        },
        reducers:{
            condition:(state = ServiceOrderModel.state.condition, action) => {
                if(action.type === 'CHANGE_SERVICE_ORDER_CONDITION'){
                    const { key, value } = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
            newModal:(state = ServiceOrderModel.state.newModal, action) => {
                if(action.type === 'CHANGE_SERVICE_ORDER_MODAL'){
                    const { key, value } = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
            page:(state = ServiceOrderModel.state.page, action) => {
                if(action.type === 'CHANGE_SERVICE_ORDER_PAGE'){
                    return Object.assign({}, state, action.page );
                }
                return state;
            },
            list:(state = ServiceOrderModel.state.list , action ) => {
                if(action.type === 'CHANGE_SERVICE_ORDER_LIST'){
                    return [ ...action.list ];
                };
                return state;
            }
        }
    }
}();

export default ServiceOrderModel;


// WEBPACK FOOTER //
// ./src/models/ServiceOrderModel.js